import api from './api';


const setAuthToken = token => {
    if (token && token) {
        localStorage.setItem('vip_token', token);
        api.defaults.headers.common['x-auth-token'] = token;
    } else {
        delete api.defaults.headers.common['x-auth-token'];
        localStorage.removeItem('vip_token');
    }
};

export default setAuthToken;
